module.exports = __webpack_public_path__ + "videos/mts-main-products-meetings.b80b90f.mp4";